<template>
  <div class="">
    <!--    <div class="aplication__inputs">-->
    <!--      <label for="buscador">Filtros avanzados <i v-if="hasChanges" class="btn fa fa-eraser"-->
    <!--                                                 @click.prevent="resetFilters()"></i></label>-->
    <!--      <input id="buscador" type="text" v-model="filters.search_filter" placeholder="Buscador de productos">-->
    <!--      <button>-->
    <!--        <svg id="Layer_2" style="width: 20px;height:20px;fill:white" data-name="Layer 2"-->
    <!--             xmlns="http://www.w3.org/2000/svg" viewBox="0 0 377.74 377.65">-->
    <!--          <g id="Layer_5" data-name="Layer 5">-->
    <!--            <path-->
    <!--                d="m229.79,254.76s-.01-.01-.02-.02c-1.11-1.1-2.86-1.24-4.15-.35-3.21,2.21-6.36,4.42-9.62,6.47-84.86,53.18-196.83,3.09-213.89-95.67-.82-4.73-1.42-9.49-2.12-14.24.02-6.72.04-13.33.06-20.06.87-5.73,1.58-11.49,2.71-17.17C14.41,55.54,61.24,10.66,119.59,1.66c74.4-11.48,145.39,37.86,159.93,111.77,7.96,40.46-.48,77.74-24.61,111.33-.07.1-.14.2-.21.3-.94,1.31-.8,3.1.34,4.24,35.24,35.24,99.27,101.83,119.95,123.38,3.7,3.85,3.67,9.94-.06,13.76-2.89,2.95-6.1,6.23-8.27,8.46-3.47,3.55-9.13,3.7-12.79.33-21.48-19.79-88.68-85.05-124.08-120.46Zm17.3-113.48c0-58.46-47.37-105.96-105.77-106.07-58.41-.11-106.25,47.74-106.17,106.16.09,58.36,47.63,105.77,106.07,105.78,58.45.01,105.87-47.41,105.87-105.87Z"/>-->
    <!--          </g>-->
    <!--        </svg>-->
    <!--      </button>-->
    <!--    </div>-->

    <!--    <div class="row w-100 my-3">-->
    <!--      <div class="col-lg-3" v-if="config.categories && config.categories.length > 0">-->
    <!--        <div class="d-flex filter-label" style="border-radius: 5px 5px 0 0;">-->
    <!--          <div style="flex:1;"></div>-->
    <!--          <h5 style="font-weight: 700;" class="py-1 mt-1">Categoría</h5>-->
    <!--          <div style="flex:1;"></div>-->
    <!--        </div>-->

    <!--        <treeselect-->
    <!--            v-model="filters.category_ids"-->
    <!--            :normalizer="treeSelectNormalizer"-->
    <!--            :multiple="true"-->
    <!--            :options="config.categories"-->
    <!--            class="main-input"-->
    <!--        />-->

    <!--      </div>-->

    <!--      <div class="col-lg-3" v-if="config.bases && config.bases.length > 0">-->
    <!--        <div class="d-flex filter-label" style="border-radius: 5px 5px 0 0;">-->
    <!--          <div style="flex:1;"></div>-->
    <!--          <h5 style="font-weight: 700;" class="py-1 mt-1">Base</h5>-->
    <!--          <div style="flex:1;"></div>-->
    <!--        </div>-->
    <!--        <select v-model="filters.bases" class="main-input">-->
    <!--          <option :value="null">Todos</option>-->
    <!--          <option v-for="(base, index) in config.bases" :value="base" :key="index">{{ base }}</option>-->
    <!--        </select>-->
    <!--      </div>-->

    <!--      <div class="col-lg-3" v-if="config.isos && config.isos.length > 0">-->
    <!--        <div class="d-flex filter-label" style="border-radius: 5px 5px 0 0;">-->
    <!--          <div style="flex:1;"></div>-->
    <!--          <h5 style="font-weight: 700;" class="py-1 mt-1">Especificación</h5>-->
    <!--          <div style="flex:1;"></div>-->
    <!--        </div>-->
    <!--        <select v-model="filters.isos" class="main-input">-->
    <!--          <option :value="null">Todos</option>-->
    <!--          <option v-for="(iso, index) in config.isos" :value="iso" :key="index">{{ iso }}</option>-->
    <!--        </select>-->
    <!--      </div>-->

    <!--      <div class="col-lg-3" v-if="config.brands && config.brands.length > 0">-->
    <!--        <div class="d-flex filter-label" style="border-radius: 5px 5px 0 0;">-->
    <!--          <div style="flex:1;"></div>-->
    <!--          <h5 style="font-weight: 700;" class="py-1 mt-1">Marca</h5>-->
    <!--          <div style="flex:1;"></div>-->
    <!--        </div>-->
    <!--        <select v-model="filters.brand" class="main-input">-->
    <!--          <option :value="null">Todos</option>-->
    <!--          <option v-for="(brand, index) in config.brands" :value="brand._id.$oid" :key="index">-->
    <!--            {{ brand.name }}-->
    <!--          </option>-->
    <!--        </select>-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</template>
<script>
import _ from 'lodash';
import filters_mixins from '../mixins/filters_mixin.js';
import Treeselect from "@riophae/vue-treeselect";
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  components: {Treeselect},
  mixins: [filters_mixins],
  props: {
    config: {
      type: Object
    }
  },
  data() {
    return {
      filters: {
        search_filter: "",
        page_size: 12,
        category_ids: [],
        isos: null,
        bases: null,
        brand: null,
      },
      defaultFilters: {
        search_filter: "",
        page_size: 12,
        categories: null,
        isos: null,
        bases: null,
        brand: null,
      },
      pageSizeOptions: [8, 10, 12, 24, 48],
      defaultPrices: [0, 1000, 2500, 5000, 10000, 25000, 50000, 100000]
    }
  },
  watch: {
    filters: {
      handler: _.debounce(function (newItem) {
        this.refresh();
        if (this.config != null) this.syncPageParams(window.location.href);
      }, 1000),
      immediate: true,
      deep: true
    },
    'filters.search_filter': {
      handler: function (newItem) {
        if (newItem) {
          this.filters.category_ids = null;
          this.filters.isos = null;
          this.filters.bases = null;
          this.filters.brand = null;
        }
      },
      immediate: true,
    },
    config: {
      handler: function (newItem) {
        if (newItem) this.getFiltersParamsFromUrl();
      },
      immediate: true,
    },
  },
  methods: {
    refresh() {
      this.$emit("refresh", this.filters);
    },

    treeSelectNormalizer(item) {
      // used by the vue-treeselect control
      return {
        id: item._id ? item._id.$oid : item,
        label: item.name
      };
    },
  }
}
</script>
<style lang="scss" scoped>
.txt-line {
  border-top: solid grey 2px;
  margin-top: 15px;
}

.circle {
  width: 25px;
  height: 25px;
  border-radius: 100%;
  border: solid black 1px;
}

.radios {
  align-items: center;
}

.btnaws {
  cursor: pointer;
  margin: 3px;
}

.nowrap {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>